import { env } from 'Shared/constants/env';

/**
 * Gets intelligent default filters based on environment
 */
export const getDefaultFilters = () => {
  const environment = env.survicateEnvironment;

  return {
    ...(environment && { environment }),
    assetType: 'product',
  };
};
